import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Backdrop,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { Logout } from "@mui/icons-material";

import api, { baseURL } from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardPageNumber,
  setFilesPartsEmpty,
} from "../slice/searchPaginationSlice";
import axios from "axios";

const DummyAdmitCardStudents = () => {
  const navigate = useNavigate();
  const { schoolId } = useParams();
  console.log(schoolId, "schoolId");
  const location = useLocation();
  const { agencyName } = location?.state || "";
  const [loading, setLoading] = useState(true);
  const [fileUploadLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [count, setCount] = useState(0);

  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false);

  const [schoolPageNumber, setSchoolPageNumber] = useState(0);

  const [paymentType, setPayment] = useState("Pending");
  const handleDropdownChange = (event) => {
    const { value } = event.target;
    setPayment(value);
  };

  const dispatch = useDispatch();
  const [schoolCode, setSchoolCode] = useState(schoolId);
  useEffect(() => {
    dashboardData();
  }, [schoolPageNumber]);

  const userInfo = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))
    : null;

  const dashboardData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `https://results.biharboardonline.com/rapi/api/App25/GetDeclrDetails`
      );
      console.log(response, "response");
      setDashboardList([...response?.data]);
      setCount(response?.data?.count);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };

  return (
    <>
      {/* Image Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {/* {fileUploadLoading ? (
          <Backdrop
            open={fileUploadLoading}
            style={{ zIndex: 9999, color: "#fff" }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null} */}

        <Box
          // display="flex"
          // flexWrap="wrap"
          gap="10px"
          // justifyContent="space-between"
          alignItems="center"
          // flexDirection="row"
          mb={3}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginBottom: "10px", width: "91%" }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              Dummy Students Report
            </Typography>
            {/* <Box
              style={{
                width: "650px",
                // backgroundColor: "red",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <TextField
                label="school Code"
                name="schoolCode"
                type="text"
                variant="outlined"
                size="small"
                value={schoolCode}
                onChange={(e) => setSchoolCode(e?.target?.value)}
                // inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
                // onInput={(e) => {
                //   e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                // }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  dashboardData(schoolCode);
                }}
                style={{ textTransform: "none" }}
                // disabled={
                //   schoolCode?.length === 5 ||
                //   schoolCode?.length === 0 ||
                //   schoolCode?.length === 9
                //     ? false
                //     : true
                // }
              >
                Search
              </Button>
            </Box> */}
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
            {/* <TextField
              id="standard-basic"
              label="Search..."
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleSearch("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            /> */}
            {/* <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dashboard");

                dispatch(setFilesPartsEmpty());
              }}
              style={{ textTransform: "none" }}
            >
              Back to Dashboard
            </Button>

            {/* {selectedRows?.length > 1 && (
              // <Button
              //   variant="text"
              //   color="primary"
              //   style={{
              //     textTransform: "none",
              //     color: "#8C0001",
              //     borderColor: "#8C0001",
              //   }}
              //   startIcon={<Download />}
              //   onClick={handleMultiDownLoad}
              // >
              //   Download Files
              // </Button>

              <Button
                onClick={handleMultiDownLoad}
                variant="outlined"
                // disabled={true}
                startIcon={<Download />}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Download Consolidated Files
              </Button>
            )} */}

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        {/* <AppBar
          position="static"
          sx={{ backgroundColor: "white", boxShadow: "none" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {agencies.map((agency, index) => (
              <Tab
                key={index}
                label={agency}
                sx={{
                  fontSize: "10px",
                }}
              />
            ))}
          </Tabs>
        </AppBar> */}

        <TableContainer
          // sx={{ maxHeight: "58vh", overflow: "auto" }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
                <TableCell align="left">
                  <strong>Reg No</strong>
                </TableCell>
                <TableCell align="left">
                  <strong>Name</strong>
                </TableCell>
                <TableCell align="left">
                  <strong>Father / Mother Name</strong>
                </TableCell>

                <TableCell align="left">
                  <strong>School Code</strong>
                </TableCell>

                {/* <TableCell align="center">
                  <strong>Total Edited Records</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Approval Records</strong>
                </TableCell> */}

                {/* <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    background: "white", // Ensures it stays visible
                    zIndex: 2, // Ensures it stays above other columns
                  }}
                >
                  <strong>Action</strong>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardList?.length > 0 ? (
                dashboardList?.map((row) => (
                  <TableRow
                    key={row?.id}
                    style={{ textWrap: "nowrap", textAlign: "center" }}
                  >
                    <TableCell style={{ textAlign: "left" }}>
                      <div>
                        <span>{row?.regno ? row?.regno : "_"}</span>
                      </div>
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      <div>
                        <span>{row?.CName ? row?.CName : "_"}</span>
                      </div>
                    </TableCell>

                    <TableCell align="left">
                      {row?.FName ? row?.FName : "_"}
                      {row?.MName ? ` / ${row?.MName}` : ""}
                    </TableCell>

                    <TableCell align="left">
                      {row?.schcd ? row?.schcd : "_"}
                    </TableCell>

                    {/* <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        marginTop: "6px",

                        background: "white", // Ensures it stays visible
                        zIndex: 1, // Ensures it stays above other columns
                      }}
                    >
                      <Button
                        variant="contained"
                        style={{
                          textTransform: "none",
                          backgroundColor: "#8C0001",
                        }}
                        disabled
                        size="small"
                        onClick={() => handleRowClick(row)}
                      >
                        View Report
                      </Button>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={count}
          rowsPerPage={50}
          page={schoolPageNumber}
          onPageChange={(event, newPage) =>
            // handleChangePage(event, newPage, "agency")
            setSchoolPageNumber(newPage)
          }
        />
        {/* <TablePagination
          // rowsPerPageOptions={[5, 10, 25, 30]}
          rowsPerPageOptions={undefined}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={dashboardPageNumber}
          onPageChange={handleChangePage}

          // onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </Container>

      {/* Loader Backdrop */}
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default DummyAdmitCardStudents;
